import React from "react";

const MissionSectionStoria = (props) => {

    return (
        <section className="mission-vision-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="mission-vision-grids clearfix">
                            <div className="grid" style={{padding:'20px', fontSize:'25px', borderRadius:'20px'}}>
                                <div className="overlay"></div>
                               
                                <p>Il<strong> 3 giugno 2022</strong> viene inaugurato il <strong>primo campo</strong> dedicato a Valerio.
In <strong>Kenya</strong>, a Korogocho, una delle tante baraccopoli di Nairobi, che sorge vicino alla grande discarica a cielo aperto di Dandora.
Sono 7 giorni di fatica e scoperta, che ci cambiano profondamente e piantano nei nostri cuori, il seme di un’idea.
</p>
                            </div>
                            <div className="grid" style={{padding:'20px', fontSize:'25px', borderRadius:'20px', display:'none'}}>
                                <div className="overlay"></div>
                               
                                <p ><strong>5 luglio</strong>: è passato appena un mese, e passiamo una giornata intera a sognare come restituire l’amore per la pallacanestro che Vale ci ha trasmesso. <strong>Sogniamo</strong> altri campi da basket, sogniamo clinic di formazione in mezzo alle baraccopoli…non ci poniamo limiti. E così, tra lacrime e risate prende forza <strong>l’idea</strong> di un’associazione che porti avanti i sogni di Valerio. Non ci sono ancora nome, logo, statuto, bilanci e la strada sembra lunghissima…ma sinceramente a noi, non importa.
</p>
                            </div>
                            <div className="grid" style={{padding:'20px', fontSize:'25px', display:'', borderRadius:'20px'}}>
                                <div className="overlay"></div>
                                
                                <p>5 luglio: è passato appena un mese, e passiamo una giornata intera a sognare come restituire l’amore per la pallacanestro che Vale ci ha trasmesso. Sogniamo altri campi da basket, sogniamo clinic di formazione in mezzo alle baraccopoli…non ci poniamo limiti. E così, tra lacrime e risate prende forza l’idea di un’associazione che porti avanti i sogni di Valerio. Non ci sono ancora nome, logo, statuto, bilanci e la strada sembra lunghissima…ma sinceramente a noi, non importa.
</p>
                            </div>
                            <div className="grid" style={{padding:'20px', fontSize:'25px', borderRadius:'20px'}}>
                                <div className="overlay"></div>
                                <p>Luglio e agosto sono <strong> mesi di fuoco</strong>, in tutti i sensi.
Ma la realtà è che molteplici tasselli vanno ad incastrarsi perfettamente l’uno con l’altro come fossero un <strong>puzzle</strong> , o forse come se qualcuno dall’alto ci desse una mano…chissà, sta di fatto che il <strong>20 settembre 2022</strong> nasce ufficialmente Vale Per Tutti con l’inaugurazione del <strong>murales</strong> ufficiale della NBA, dove sono ritratti due grandi campioni del basket, insieme a Belinelli e Ginobili.
</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MissionSectionStoria;